<!-- HHMMSS: three-part styled input -->
<ng-container *ngIf="type === 'hhmmss'">
  <div class="relative border rounded-lg bg-white h-[52px] flex items-center px-4 cursor-text transition-colors"
    [class.border-blue-600]="isFocused"
    [class.border-gray-300]="!isFocused"
    (click)="onContainerClick()"
    (focusout)="onFocusOut($event)">

    <!-- Floating label -->
    <label class="absolute bg-white px-2 pointer-events-none transition-all duration-200 truncate max-w-[90%]"
      [ngClass]="(isFocused || hasTimeValue)
        ? 'left-2 top-0 -translate-y-1/2 text-xs text-[#666666]'
        : 'left-3 top-1/2 -translate-y-1/2 text-sm text-gray-500 italic'">
      {{label}}<span *ngIf="is_required" class="text-red-700">*</span>
    </label>

    <!-- Three inputs: only shown when focused or value present -->
    <div *ngIf="isFocused || hasTimeValue" class="flex items-baseline gap-2">
      <input #hoursInput type="text" inputmode="numeric" maxlength="2"
        [disabled]="disabled || paramValue == 'true'"
        [(ngModel)]="hours_str"
        (ngModelChange)="onPartChange()"
        (keypress)="validatePartInput($event)"
        (input)="onPartInput('hours')"
        style="width:14px; height:15px; font-size:13px; padding:0;"
        class="text-gray-900 border-none outline-none bg-transparent text-center"
        placeholder="00" />
      <span class="text-gray-400 text-sm">hrs</span>
      <span class="text-gray-600 font-medium text-xl mx-1">:</span>
      <input #minutesInput type="text" inputmode="numeric" maxlength="2"
        [disabled]="disabled || paramValue == 'true'"
        [(ngModel)]="minutes_str"
        (ngModelChange)="onPartChange()"
        (keypress)="validatePartInput($event)"
        (input)="onPartInput('minutes')"
        (keydown)="onPartBackspace($event, 'minutes')"
        style="width:14px; height:15px; font-size:13px; padding:0;"
        class="text-gray-900 border-none outline-none bg-transparent text-center"
        placeholder="00" />
      <span class="text-gray-400 text-sm">Mins</span>
      <span class="text-gray-600 font-medium text-xl mx-1">:</span>
      <input #secondsInput type="text" inputmode="numeric" maxlength="2"
        [disabled]="disabled || paramValue == 'true'"
        [(ngModel)]="seconds_str"
        (ngModelChange)="onPartChange()"
        (keypress)="validatePartInput($event)"
        (keydown)="onPartBackspace($event, 'seconds')"
        style="width:14px; height:15px; font-size:13px; padding:0;"
        class="text-gray-900 border-none outline-none bg-transparent text-center"
        placeholder="00" />
      <span class="text-gray-400 text-sm">sec</span>
    </div>
  </div>
  <div class="ml-3 mt-1">
    <p *ngIf="timeError" class="text-red-500 text-sm">{{timeError}}</p>
    <ng-container *ngIf="!timeError && control && control.errors && (control.dirty || control.touched)">
      <p class="text-red-500 text-sm" *ngIf="control.errors.required">{{label}} is required.</p>
      <p class="text-red-500 text-sm" *ngIf="control.errors['zeroTime']">{{label}} cannot be 00:00:00.</p>
    </ng-container>
  </div>
</ng-container>

<!-- Other types: original input -->
<ng-container *ngIf="type !== 'hhmmss'">
  <div class="relative">
    <input [disabled]="disabled || paramValue == 'true'" (keypress)="validateInput($event)" [attr.maxlength]="type_total_latter > 0 ? type_total_latter : null" [(ngModel)]="value" (ngModelChange)="onChange($event)" [type]="(text_type && mask) ? 'password' : 'text'" [ngClass]="{
        'rounded-full': rounded,
        'rounded-lg': !rounded,
        'bg-gray-50': disabled,
        'bg-white': !disabled
      }" [id]="label" class="block p-4 w-full text-sm text-gray-900 bg-white border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-blue-600 peer" [placeholder]="placeholder || ''" />

    <label [for]="label" class="pointer-events-none left-2 absolute text-sm text-[#666666] duration-300 transform -translate-y-4 scale-75 top-2 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-gray-900 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 truncate">
      {{label}}<span *ngIf="is_required" class="col-span-2 text-red-700 text-opacity-60">*</span>
    </label>

    <button *ngIf="fetch" (click)="fetch_clicked()" class="text-blue-500 text-sm absolute font-medium right-4 top-3">Fetch</button>

    <button *ngIf="copyable" (click)="copy_clicked()" class="text-gray-600 text-sm absolute right-2 top-[10px] active:bg-gray-50 hover:bg-gray-100 rounded-full p-2" title="Copy">
      <i class='bx bx-copy text-xl'></i>
    </button>

    <button *ngIf="mask" (click)="eye_clicked()" class="text-blue-500 text-sm absolute right-4 top-3">
      <i class='bx bx-show text-xl'></i>
    </button>
  </div>

  <div *ngIf="control && control.errors && (control.dirty || control.touched)" class="ml-3 mt-1">
    <p class="text-red-500" *ngIf="control.errors.required">{{label}} is required.</p>
    <p class="text-red-500" *ngIf="control.errors.minlength">Minimum length required is {{ control.errors.minlength.requiredLength }}.</p>
    <p class="text-red-500" *ngIf="control.errors.maxlength">Maximum length allowed is {{ control.errors.maxlength.requiredLength }}.</p>
    <p class="text-red-500" *ngIf="control.errors.pattern">Please enter a valid {{label}} value</p>
    <p class="text-red-500" *ngIf="control.errors['email']"> Invalid email format.</p>
    <p class="text-red-500" *ngIf="control.errors['zeroTime']">{{label}} cannot be 00:00:00.</p>
  </div>
</ng-container>
